// NOTE: This file is autogenerated from `libs/errorcodes.go`. Run `npm run gen-errorcodes` to update this file.
// ErrorCode identifies an error code

// Error Codes
// user
// Indicates that the user's input was the source of the issue. Likely recoverable by the end
// user modifying a value or taking some other action.

// User supplied an invalid value. This ErrorMessage should include meta data about what fields were invalid when applicable.
export const ERROR_CODE_USER_INVALID_VALUE = 'user.general.invalid_value';

// User was unauthorized to make the request.
export const ERROR_CODE_USER_REQUIRED_FIELD = 'user.general.required_field_missing';

// User spuplied a duplicate entry
export const ERROR_CODE_USER_DUPLICATE_RESOURCE = 'user.general.duplicate_resource';

// User was unauthorized to make the request.
export const ERROR_CODE_USER_UNAUTHORIZED = 'user.general.unauthorized';

// User has been banned
export const ERROR_CODE_USER_BANNED = 'user.general.banned';

// User referenced an entity that does not exist
export const ERROR_CODE_USER_EVENT_DOES_NOT_EXIST = 'user.general.event_does_not_exist';

// User referenced an entity that does not exist
export const ERROR_CODE_USER_DOES_NOT_EXIST = 'user.general.does_not_exist';

// User attempted to create a resource that conflicts with an existing resource
export const ERROR_CODE_USER_CONFLICT = 'user.general.conflict';

// User attempted to use DRM for a stream that does not support it
export const ERROR_CODE_USER_DRM_NOT_SUPPORTED = 'user.drm.not_supported';

// User attempted to use DRM for a stream that does not support it
export const ERROR_CODE_USER_ROOMS_NOT_SUPPORTED = 'user.rooms.not_supported';

// User provided invalid stream settings
export const ERROR_CODE_USER_INVALID_STREAM_SETTINGS = 'user.streamreg.invalid_stream_settings';

// User Attempting viewing from a banned geographic region
export const ERROR_CODE_USER_BANNED_LOCATION = 'user.rules.banned_geographic_region';

// User Attempting viewing from an anonymous IP
export const ERROR_CODE_USER_BANNED_ANONYMOUS_I_P = 'user.rules.banned_anonymous_ip';

// User Access Code errors
// Access code is not valid
export const ERROR_CODE_USER_ACCESS_INVALID = 'user.access.code_invalid';
// Access code is not yet valid
export const ERROR_CODE_USER_ACCESS_PRE_WINDOW = 'user.access.code_pre_window';
// Access code is no longer valid
export const ERROR_CODE_USER_ACCESS_POST_WINDOW = 'user.access.code_post_window';
// Access code is being used by too many concurrent viewers
export const ERROR_CODE_USER_ACCESS_EXCEEDED = 'user.access.too_many_uses';
// Access code has been banned
export const ERROR_CODE_USER_ACCESS_BANNED = 'user.access.banned';

// client
// Indicates that the integrator's client likely was the source of the issue. Likely indicates a bug
// in the integrators client code and unlikely that the end user can recover.

// Client generally submitted an malformed request URL, headers or payload
export const ERROR_CODE_CLIENT_MALFORMED_REQUEST = 'client.general.malformed_request';

// Client generally returned a malformed payload
export const ERROR_CODE_CLIENT_MALFORMED_RESPONSE = 'client.general.malformed_response';

// Client did not include authentication credentials (JWT) when one was required
// Intentionally different from unauthorized (user.unauthorized)
export const ERROR_CODE_CLIENT_AUTHORIZATION_REQUIRED = 'client.general.authentication_required';

// Client referenced an invalid ticketing source
export const ERROR_CODE_CLIENT_INVALID_SOURCE = 'client.streamreg.invalid_source';

// Client referenced an invalid stream provider
export const ERROR_CODE_CLIENT_INVALID_PROVIDER = 'client.streamreg.invalid_provider';

// Client referenced an invalid metric
export const ERROR_CODE_CLIENT_INVALID_METRIC = 'client.streamreg.invalid_metric';

// Client sent a geofencing rule that overlaps another
export const ERROR_CODE_USER_RULE_OVERLAP = 'user.organizer.geofencing_rule_overlap';

// service
// Indicates this is an error that was an internal server error that is likely due to a bug
// in the service itself.

// Service had a problem actually storing the data (to disk, database, external storage, etc.)
export const ERROR_CODE_SERVICE_UNABLE_TO_PERSIST = 'service.general.unable_to_persist';

// Service had a problem deleting data (from disk, database, external storage, etc.)
export const ERROR_CODE_SERVICE_UNABLE_TO_DELETE = 'service.general.unable_to_delete';

// Service had a problem retrieving data (from disk, database, external storage, etc.)
export const ERROR_CODE_SERVICE_UNABLE_TO_RETRIEVE = 'service.general.unable_to_retrieve';

// Service had a problem communicating with an external dependency. May indicate that a third party service is down.
export const ERROR_CODE_SERVICE_EXTERNAL_ERROR = 'service.general.external';

// Service had a problem formatting a response
export const ERROR_CODE_SERVICE_UNABLE_TO_FORMAT = 'service.general.unable_to_format';

// Service had a problem parsing internal input
export const ERROR_CODE_SERVICE_UNABLE_TO_PARSE = 'service.general.unable_to_parse';

// Service referenced closed channel
export const ERROR_CODE_SERVICE_CHANNEL_CLOSED = 'service.general.channel_closed';

// Service had an unspecified problem
export const ERROR_CODE_SERVICE_UNSPECIFIED = 'service.general.unspecified_error';
